import { render } from "./SelfMediaTraining.vue?vue&type=template&id=25c4b0fe&scoped=true"
import script from "./SelfMediaTraining.vue?vue&type=script&lang=js"
export * from "./SelfMediaTraining.vue?vue&type=script&lang=js"

import "./SelfMediaTraining.vue?vue&type=style&index=0&id=25c4b0fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c4b0fe"]])

export default __exports__